import request from '../Functions/ajax/request'

export default function PersonNameLoader ({ params })
{
	return { page: getPersonName({ params }), params };
}

async function getPersonName ({ params })
{
	var { person_name } = await request('/enterrements/get-person-name')
	.config({ })
	.post({ id: params.id });

	return { person_name: person_name };
}